import {
  all,
  converge,
  curryN,
  evolve,
  intersection,
  keys,
  length,
  pick,
  pipe,
  values,
} from "ramda";

export const evolveSome = converge(pick, [keys, evolve]);

export const hasIntersection = curryN(2, pipe(intersection, length, Boolean));

export const allPropsPass = (obj) =>
  pipe(evolveSome(obj), values, all(Boolean));
